import axios from 'axios';
import { API_URL } from '../../../config/api';

const headers = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
  'Content-Type': 'application/json',
});

export const fetchDestinations = async () => {
  const response = await axios.get(`${API_URL}/travel/destinations`, { headers: headers() });
  return Array.isArray(response.data) ? response.data : [];
};

export const createDestination = async (name) => {
  const response = await axios.post(
    `${API_URL}/travel/destinations`,
    { name },
    { headers: headers() },
  );
  return response.data;
};

export const fetchDestination = async (id) => {
  const response = await axios.get(`${API_URL}/travel/destinations/${id}`, { headers: headers() });
  return response.data;
};

export const addDestinationFile = async (id, payload) => {
  const response = await axios.post(
    `${API_URL}/travel/destinations/${id}/files`,
    payload,
    { headers: headers() },
  );
  return response.data;
};

export const removeDestinationFile = async (id, fileId) => {
  const response = await axios.delete(
    `${API_URL}/travel/destinations/${id}/files/${fileId}`,
    { headers: headers() },
  );
  return response.data;
};

export const deleteDestination = async (id) => {
  const response = await axios.delete(`${API_URL}/travel/destinations/${id}`, { headers: headers() });
  return response.data;
};
